export default "__VITE_ASSET__BqJ3tyJk__"